import React, { useEffect, useState } from "react";
import { SecondHeading } from "../../../Components/Utils/Heading";
import SearchBar from "../../../Components/Utils/SearchBar";
import { Link, useLocation, useParams } from "react-router-dom";
import { CancelButton, CreateButton, FilterButton, SubmitButton } from "../../../Components/Utils/Buttons";

import NoteCard from "./NoteCard";
import axios from "../../../Services/axiosCommon";
import { Modal } from "antd";

import { useFormik } from "formik";
import useFetchMataData from "../../../Components/Hooks/useFetchMataData";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";
import Dashboard from "../Dashboard";
import { GetAccess } from "../../../Components/Utils/roles";
import { NuDate, NuSelect } from "../../../Components/Utils/Input";
import FormikSelectTwo from "../../../Components/Utils/Select";
import * as yup from 'yup';
import UseGetDataSearchByPro from "../../../Components/Hooks/useFetchDataByPRO";



export default function Notes() {
  const {officeId} = useParams();
  // const {value} = useFetchMataData(`/Metadata/noteStatus`)
  const { value: noteStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "noteStatus"
  );
  // const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
 

   const location = useLocation();
    const currentPage= location.state?.currentPage
    const searchQuery= location.state?.searchQuery
    const [page, setPage] = useState(currentPage||1)
    const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
    const [filter, setFilter] = useState(false);
     const [showFilterDialog, setShowFilterDialog] = useState(false);
      

  const [filterProps, setFilterProps] = useState({
   
    status:"",
    dueDateFrom:"",
    dueDateTo:"",
  
  });
  const [params, setParams] = useState({
      page: page,
      per_page: pageCount,
      search:searchQuery||"",
      status:"", 
      dueDateFrom:"",
      dueDateTo:"",
    });

    const clearFilter = ()=> {
      setParams({...params,
      status:"",
      dueDateFrom:"",
      dueDateTo:"",
     
    })
    
    formik.values.status=""
    formik.values.dueDateFrom=""
    formik.values.dueDateTo="" 
  
  
        setFilter(false)
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: filterProps,
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema: yup.object({
          // email: yup.string().required('Email is required!'),
        }),
        onSubmit: async (value, { resetForm }) => {
          console.log("ffff",value);
          setParams({...params,status:value.status,dueDateTo:value.dueDateTo,dueDateFrom:value.dueDateFrom})
          closeFilterDialog();
          setFilter(true)
          setFilterProps({
          
            status:"",
            dueDateFrom:"",
            dueDateTo:"",
           
          });
        }
      })
  
  const { data, totalPro,totalCount, getData,dataLoading } = UseGetDataSearchByPro( `/Notes/byUser`,params);
  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  return (
    <div className="w-full mx-auto px-4 py-2">
      <div className="md:flex justify-between w-full">
      <Breadcrumb
          items={[
            { name: "My Diary" },
          ]} />
        <div className=" flex justify-between items-center">
          <div className=" pb-2 w-full flex justify-between items-center ">
            <div className="flex justify-end items-center gap-3 ">
              <form className="flex items-center mx-0" onSubmit={getData}>
              <SearchBar
              handleChange={(e) =>{
                setParams({ ...params, search: e.target.value, page:1 });
                setPage(1)
              }}
              value={params.search||searchQuery}
            />
              </form>
              <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
                        {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>}
                      
           
              {GetAccess() && (
                <Link to={`/dairy/create`}>
                  <CreateButton label="Note" />
                </Link>
               )} 
            </div>
          </div>
        </div>
      </div>

      <div className=" w-full h-[80vh] overflow-y-auto bg-white rounded-md">
        {/* <p className="px-2 pt-2 text-xs  text-[#111537] text-left font-semibold" >My Diary</p> */}
                <div
          className={`flex flex-wrap w-full ${
            totalRows >= 10 ? "h-full" : "h-auto"
          } overflow-y-scroll`}
        >
          {data &&
            data.map((item, idx) => {
              return (
                <NoteCard
                  width="w-full sm:w-1/2 lg:w-1/4 xl:w-1/5"
                  data={item}
                  getNotes={getData}
                  id={item?.notesId}
                  key={idx}
                />
              );
            })}
        </div>
      </div>
      {showFilterDialog && (
             
             
             <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
               <div className="animate-scale-in min-w-[50%] max-w-[70%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                 <h2 className="text-xl mb-4">Filter Notes</h2>
                 <form onSubmit={formik.handleSubmit}> 
                   <div className="flex flex-col mb-4">
                                      <p className="py-2 px-6 text-m">Due Date</p>
                                      <div className="flex justify-between  w-full ">
                                      <NuDate
                                label=" From"
                                placeholder="dd/mm/yyyy"
                                formik={formik}
                                name="dueDateFrom"
                                width="w-full"
                              />
                                <NuDate
                                label=" To"
                                placeholder="dd/mm/yyyy"
                                formik={formik}
                                name="dueDateTo"
                                width="w-full"
                              />
                              </div>                 
                                 {/* <FormikSelectTwo
              label="Status"
              Options={noteStatus}
              formik={formik}
              placeholder="Choose"
              name="status"
              width=" w-full"
            /> */}
             <FormikSelectTwo
                  label="Status"
                  Options={[
                    {value:'open',label:'Open'},
                    {value:'pending',label:'Pending'},
                    {value:'close',label:'Close'},

                  ]}
                  formik={formik}
                  placeholder="Choose"
                  name="status"
                  width="w-full "
                  isRequired={true}
                />
                    </div>
                   <div className="flex justify-end gap-2">
                     <CancelButton handleClick={closeFilterDialog} />
                     <SubmitButton name='Apply' />
                   </div>
                  </form> 
               </div>
             </div>
           )}
      {/* <Modal
        open={open}
        title={"Filter Notes"}
        width={"25%"}
        className="my-modal"
        centered
        onCancel={() => setOpen(false)}
        footer={[]}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className=" w-full flex flex-wrap">
            <FormikSelectTwo
              label="Status"
              Options={noteStatus}
              formik={formik}
              placeholder="Choose"
              name="filter"
              width=" w-full"
            />
          <button
              type="submit"
              // htmlType="submit"
              // size="large"
              className="w-11/12 bg-[#048178] py-3 rounded-lg cursor-pointer text-sm outline-none border-none hover:text-white focus:text-white text-white  mx-auto"
            >
              Filter
            </button>
          </div>
        </form>
      </Modal> */}
    </div>
  );
}
